import React, { PureComponent, useRef, useEffect, useState, useMemo, useCallback } from 'react';
import { JqueryClassFaker } from '../../components/JqueryClassFaker';
import useWavesEffect from "../hooks/useWavesEffect";
import withDefaultProps from 'functions/withDefaultProps';

export default function TabButton(incomingProps) {
	const props = withDefaultProps(incomingProps, defaultProps);
	const {
		className, selectedTab, selected, contains, name, onClick, content, limitedGlow,
		badge, tabTip, tabPaneClassName, text, children, pulseGlow, tab, whenContentIsLoadedRender,
		...restOfTheProps
	} = props;

	const ref = useRef(null);

	const [pulseGlowing, updatePulseGlowing] = useState(false);
	const [containedChildren, updateContainedChildren] = useState({});

	const isSelected = selectedTab === name || selected || (contains && contains[selectedTab]) || containedChildren[selectedTab];

	useWavesEffect(ref);
	useEffect(() => {
		const contains = {};
		_.flatten(children).map((child) => {
			if(!child || !child.props || !child.props.name) {
				return null;
			}
			contains[child.props.name] = true;
		});
		updateContainedChildren(contains);
	}, [children]);

	useEffect(() => {
		let glowTimeLimit = null;

		function startLimitedGlow() {
			endLimitedGlow();
			updatePulseGlowing(true);
			if(limitedGlow) {
				return setTimeout(() => {
					endLimitedGlow();
				}, 8000);
			}
		}

		function endLimitedGlow() {
			clearTimeout(glowTimeLimit);
			updatePulseGlowing(false);
		}

		if(pulseGlow) {
			glowTimeLimit = startLimitedGlow(updatePulseGlowing);
		}
		else {
			endLimitedGlow();
		}
		return () => {
			endLimitedGlow();
		};
	}, [pulseGlow, limitedGlow]);

	const onClickHandler = useCallback(() => {
		const { onClick, name } = props;
		if(!onClick) {
			return;
		}
		onClick(name);
	}, [onClick, name]);

	const classes = useMemo(() => {
		const classes = new JqueryClassFaker(className);
		classes.toggleClass('active', isSelected);
		classes.toggleClass('pulse_glow', pulseGlowing);
		classes.toggleClass('highlighted', pulseGlow && !pulseGlowing);
		classes.add('waves-effect');
		classes.add('waves-light');
		return classes;
	}, [className, isSelected, pulseGlowing, pulseGlow]);


	restOfTheProps.name = name;

	return (
		<li
			ref={ref}
			className={`btn btn-sm tab_button ${classes.toString()}`}
			onClick={onClickHandler}
			{...restOfTheProps}
		>
			{text || children || tab}
			{((Number.isInteger(badge) && badge !== 0) || !!badge) &&
			<span className='count active badge'>{badge}</span>
			}
			{tabTip !== undefined &&
			<span className='tab_tip'>{tabTip}</span>
			}
		</li>
	);
}

const defaultProps = {
	badge: 0,
	pulseGlow: false,
	limitedGlow: true,
};
